module.exports = __webpack_public_path__ + "img/decline.faee2f83.jpg";